import React from 'react';
import { useParams } from 'react-router-dom';
import AdminDeletionQueue from './AdminDeletionQueue';
import AdminDbBackupDeletionQueue from './AdminDbBackupDeletionQueue';

/**
 * All Statuses uses one route param; db-backup-deletion has a different workflow than contact/account queues.
 */
export default function AdminAllStatusesRouter() {
  const { queueType } = useParams();
  if (queueType === 'db-backup-deletion') {
    return <AdminDbBackupDeletionQueue />;
  }
  return <AdminDeletionQueue />;
}
